import { api } from 'store/api'

export function getExtension(path: string): string {
  const dot = path.lastIndexOf('.')
  if (dot < 0) return ''
  const ext = path.substring(dot + 1)
  const good = /^\w+$/.test(ext)
  return good ? ext : ''
}

function isVideo(url: string): boolean {
  try {
    const { pathname } = new URL(url)
    const ext = getExtension(pathname)
    return ext === 'mp4'
  } catch (e) {
    console.error(e)
    return false
  }
}

export async function fetchCorsFile(url: string): Promise<File | undefined> {
  try {
    const video = isVideo(url)
    const blob = await api.download(url)
    const name = video ? 'video.mp4' : 'image.jpg'
    const type = video ? 'video/mp4' : 'image/jpeg'
    return new File([blob], name, { type })
  } catch (e) {
    console.error('fetch failed', e)
    return undefined
  }
}

export async function downloadFile(url: string): Promise<boolean> {
  const video = isVideo(url)
  const file = await fetchCorsFile(url)
  if (!file) return false
  const href = URL.createObjectURL(file)
  
  if (window.Telegram?.WebApp) {
    window.Telegram.WebApp.openLink(href, { try_instant_view: false })
    setTimeout(() => window.URL.revokeObjectURL(href), 1000)
    return true
  }
  
  const a = document.createElement('a')
  a.href = href
  a.download = video ? 'video.mp4' : 'image.jpg'
  a.type = video ? 'video/mp4' : 'image/jpeg'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  window.URL.revokeObjectURL(href)
  return true
}
